// extracted by mini-css-extract-plugin
export var currentStep = "_gj-2";
export var nodeCard = "_gj-0";
export var pathHighlighted = "_gj-1";